module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/desktop-7feab0d8645640eeca0e1b8716cb6195.jpg";